export const GetScrollTimeStyle = wordCount => {
	return {
		transition: Math.floor(Math.sqrt(wordCount) - 3).toString() + 's',
	};
};
